// MinMaxSlider.js
import React from 'react';
import Slider from '@mui/material/Slider';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InputGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  input {
    width: 80px;
    padding: 4px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 20px;
  font-family: Montserrat;
  font-weight: 400;
  font-size: 12px;
  input {
    width: 67px;
    box-shadow: 0px 0px 8px 0px #a2a2a23d;
    border: 1px solid #d9d9d9;
    margin-top: 5px;
    margin-left: -3px;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    color: #636363;

    padding: 5px 10px;
    border-radius: 5px;
  }
`;

const MinMaxLabels = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding: 0 6px;
`;

const MinMaxSlider = ({
  label = 'Likes',
  value = [0, 50000],
  onChange,
  min = 0,
  max = 100000,
}) => {
  const handleSliderChange = (_, newValue) => {
    onChange(newValue);
  };

  const handleInputChange = (index, val) => {
    const newVals = [...value];

    if (val === '') {
      // Allow user to clear input temporarily
      newVals[index] = null;
      onChange(newVals);
      return;
    }

    const num = Number(val);
    if (!isNaN(num)) {
      newVals[index] = Math.max(0, num);
      if (newVals[0] <= newVals[1]) {
        onChange(newVals);
      }
    }
  };

  return (
    <Wrapper>
      <Label>
        Min
        <input
          type='number'
          value={value[0] === '' ? '' : value[0]}
          onChange={(e) => handleInputChange(0, e.target.value)}
        />
        Max
        <input
          type='number'
          value={value[1] === '' ? '' : value[1]}
          onChange={(e) => handleInputChange(1, e.target.value)}
        />
      </Label>

      <Slider
        value={value}
        min={min}
        max={max}
        sx={{
          color: '#2D8955',
        }}
        onChange={handleSliderChange}
        disableSwap
      />

      <MinMaxLabels>
        <span>{min}</span>
        <span>{max >= 100000 ? '100k+' : max}</span>
      </MinMaxLabels>
    </Wrapper>
  );
};

export default MinMaxSlider;
